<template>
    <div class="view-container">
        <modal :showDialog="activeModal === 'ADD'" @close="closeModal" :title="$t('AddUser').toUpperCase()">
            <user-modal @cancel="closeModal" @save="closeModal('getData')"></user-modal>
        </modal>
        <modal :showDialog="activeModal === 'EDIT'" @close="closeModal" :title="$t('EditUser').toUpperCase()">
            <user-modal :userObj="activeUser" @cancel="closeModal" @save="closeModal('getData')"></user-modal>
        </modal>
        <modal :showDialog="activeModal === 'DELETE'" @close="closeModal" :title="$t('DeleteUser').toUpperCase()">
            <delete-confirm @cancel="closeModal" @confirm="deleteUser" :text="deleteText"></delete-confirm>
        </modal>
        <modal :showDialog="activeModal === 'SHOW_PASSWORD_PIN'" @close="closeModal" :title="$t('INSERT_PIN')">
            <pin-modal @cancel="closeModal" :text="$t('enterPin')" @confirm="closePinModal" :actionType="'SHOW_PASSWORD'"></pin-modal>
        </modal>
        <modal :showDialog="activeModal === 'SHOW_RESET_PASSWORD_MODAL'" @close="closeModal" :title="$t('RESET_PASSWORD')">
            <restore-password-modal @cancel="closeModal" @confirm="closeModal" :email="activeUser" :text="$t('reset_password')"/>
        </modal>
		<div style="width: 100%; height: 100%; overflow-x: auto">
			<div class="max-grid">
				<ejs-grid ref="grid" height='100%' width='100%' :toolbar='$store.getters.isAdmin ? toolbar : null' :toolbarClick='toolbarClick' :selectionSettings='selectionOptions' :allowTextWrap="true" :textWrapSettings='wrapSettings' :dataBound='dataBound' :dataSource="users" :allowPaging="true" :pageSettings='pageSettings' :allowFiltering='true' :filterSettings='filterOptions' :allowSorting='true' :allowMultiSorting='true' :sortSettings="sortOptions" :allowPdfExport='true' :allowCsvExport='true' :allowExcelExport='true' :showBusyIndicator="true" >
					<e-columns>
						<e-column field='fullName' :headerText="$t('UserName')" textAlign='Left' :customAttributes="customAttributes"></e-column>
						<e-column field='email' :headerText="$t('Email')" textAlign='Left' :customAttributes="customAttributes"></e-column>
						<e-column field='role' :headerText="$t('Role')" textAlign='Left' :customAttributes="customAttributes" :filter="filterCheckBox" width="200px"></e-column>
						<e-column field='systemsText' type='string' :headerText="$t('AccessToSystem')" textAlign='Left' :template="systemsTemplate" :customAttributes="customAttributes" :filter="systemsFilter"></e-column>
						<e-column field='systemGroupsText' type='string' :headerText="$t('SystemGroups')" textAlign='Left' :template="systemGroupsTemplate" :customAttributes="customAttributes" :filter="systemGroupsFilter"></e-column>
						<e-column v-if="$store.getters.isAdmin" field='id' headerText="" width="150px" :allowSorting="false" :allowFiltering="false" :template="optionsTemplate"></e-column>
					</e-columns>
				</ejs-grid>
			</div>
		</div>
    </div>
</template>

<script>
import Button from '@/components/Button'
import { getAllUsers, deleteUser, getUserSystems } from '@api'

import { Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport } from '@syncfusion/ej2-vue-grids';
import { DataUtil } from '@syncfusion/ej2-data';
import { MultiSelect } from '@syncfusion/ej2-dropdowns';
import Modal from '@/components/Modal.vue'
import UserModal from '@/components/Users/UserModal.vue'
import DeleteConfirm from '@/components/DeleteConfirm.vue'
import Vue from "vue";
import EditUserRole from '@/components/Users/EditUserRole.vue';
import PinModal from '../../components/Users/PinModal.vue';
import RestorePasswordModal from '../../components/Users/RestorePasswordModal.vue';

export let context = null

const LIST_SEPARATOR = ', '

// Kolumny z listą nazw (systemy, grupy) – rekord pasuje, gdy lista zawiera wybraną nazwę.
// Filtr z wieloma wartościami grid łączy przez OR, więc wystarczy dopasowanie pojedynczej nazwy.
DataUtil.fnOperators.hasitem = function (actual, expected, ignoreCase) {
    if (actual == null || expected == null) return false
    let list = LIST_SEPARATOR + actual + LIST_SEPARATOR
    let item = LIST_SEPARATOR + expected + LIST_SEPARATOR
    if (ignoreCase) {
        list = list.toLowerCase()
        item = item.toLowerCase()
    }
    return list.indexOf(item) !== -1
}

function joinNames(items) {
    return (items || []).map(x => x.name).join(LIST_SEPARATOR)
}

function distinctNames(users, key) {
    const names = new Set()
    users.forEach(u => (u[key] || []).forEach(x => names.add(x.name)))
    return Array.from(names).sort((a, b) => a.localeCompare(b))
}

function listFilter(getOptions) {
    let multiSelect = null
    return {
        type: 'Menu',
        ui: {
            create: (args) => {
                const operator = args.target.parentElement.querySelector('.e-flm_optrdiv')
                if (operator) operator.style.display = 'none'
                const input = document.createElement('input')
                args.target.appendChild(input)
                multiSelect = new MultiSelect({
                    dataSource: getOptions(),
                    placeholder: context.$t('search'),
                    allowFiltering: true,
                    popupHeight: '250px',
                })
                multiSelect.appendTo(input)
            },
            write: (args) => {
                const selected = args.parent.filterSettings.columns
                    .filter(c => c.field === args.column.field)
                    .map(c => c.value)
                multiSelect.value = selected.length ? selected : null
            },
            read: (args) => {
                args.fltrObj.removeFilteredColsByField(args.column.field)
                const values = multiSelect.value || []
                if (values.length)
                    args.fltrObj.filterByColumn(args.column.field, 'hasitem', values)
            }
        }
    }
}

function ellipsisTemplate(field) {
    return function() {
        return {
            template: Vue.component('ellipsisTemplate_' + field, {
                template: `
                    <div style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden !important;">{{ data.${field} }}</div>
                `,
                data: function(){
                    return {
                        data: {}
                    }
                }
            })
        }
    }
}

export default {
    props: {
    },
    provide: {
        grid: [ Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport ]
    },
    components: {
        Button,
        Modal,
        UserModal,
        DeleteConfirm,
        EditUserRole,
        PinModal,
        RestorePasswordModal
    },
    data() {
        return {
            users: [],
            activeModal: 'NONE',
            activeUser: null,
            deleteText: '',

            pageSettings: { pageSize: 100, pageSizes: [10,25,50,100] },
            toolbar: [
                { text: this.$t('Users'), align: 'Left', id: 'table-title'},
                { text: this.$t('ClearFilter'), id: 'clear-filters', prefixIcon: 'e-cancel', align: 'Right',},
                { text: this.$t('Excelexport'), prefixIcon: 'e-excelexport', align: 'Right', id: 'excel-export'},
                { text: this.$t('Pdfexport'), prefixIcon: 'e-pdfexport', align: 'Right', id: 'pdf-export'},
                { text: this.$t('Csvexport'), prefixIcon: 'e-csvexport', align: 'Right', id: 'csv-export'},
                { text: this.$t('AddUser'), tooltipText: 'Add User', prefixIcon: 'e-add', id: 'addUser', align: 'Right' },
                'Search'
            ],
            wrapSettings: { wrapMode: 'Content' } ,
            selectionOptions: { type: 'Multiple' },
            filterOptions: {
                type: 'Menu',
            },
            filterCheckBox: {
                type: 'CheckBox',
            },
            sortOptions: {
                columns: [
                    { field: 'role', direction: 'Ascending' }
                ]
            },
            customAttributes : {class: 'customcss'},
            optionsTemplate: function() {
                return {
                    template: Vue.component('optionsTemplate', {
                        template: `
                            <div class="horizontal grow">
                                <div class="" style="cursor: pointer; margin: 5px" v-on:click="onClick('PASSWORD')" content="${ context.$t('Password') }" v-tippy="{ theme : 'customTheme', placement : 'left', arrow : true }">
                                    <svg width="27" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.6667 8.99988L12 11.9999M12 11.9999L10.3333 8.99988M12 11.9999H9.5M12 11.9999H14.5M12 11.9999L10.3333 14.9999M12 11.9999L13.6667 14.9999M6.16667 8.99994L4.5 11.9999M4.5 11.9999L2.83333 8.99994M4.5 11.9999H2M4.5 11.9999H7M4.5 11.9999L2.83333 14.9999M4.5 11.9999L6.16667 14.9999M21.1667 8.99994L19.5 11.9999M19.5 11.9999L17.8333 8.99994M19.5 11.9999H17M19.5 11.9999H22M19.5 11.9999L17.8333 14.9999M19.5 11.9999L21.1667 14.9999" stroke="#346F8B" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                </div>
                                <div class="" style="cursor: pointer; margin: 5px" v-on:click="onClick('EDIT')" content="${ context.$t('Edit') }" v-tippy="{ theme : 'customTheme', placement : 'left', arrow : true }">
                                    <svg width="27" height="20" viewBox="0 0 27 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.64951 16.4004L7.64952 16.4003M7.64951 16.4004L7.64951 16.4004L7.64952 16.4003M7.64951 16.4004C7.64952 16.4004 7.64952 16.4003 7.64952 16.4003M7.64951 16.4004L7.64952 16.4003M14.95 7.25429L17.4952 9.61783L10.5666 16.0519L7.66216 16.3496L7.66203 16.3496C7.65971 16.3499 7.65755 16.35 7.65555 16.35L7.96842 13.737L14.95 7.25429ZM18.5296 4.83337L20.1732 6.35962C20.4089 6.57848 20.4091 6.91217 20.1731 7.13143L19.0692 8.15645L16.524 5.79293L17.5573 4.83337C17.8206 4.58888 18.2663 4.58888 18.5296 4.83337Z" stroke="#346F8B" stroke-width="1.3"/></svg>
                                </div>
                                <div class="" style="cursor: pointer; margin: 5px" v-on:click="onClick('DELETE')" content="${ context.$t('Delete') }" v-tippy="{ theme : 'customTheme', placement : 'left', arrow : true }">
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 1.4C3.5 0.626801 4.1268 0 4.9 0H9.1C9.8732 0 10.5 0.626801 10.5 1.4V2.8H11.8928C11.8971 2.79996 11.9014 2.79996 11.9058 2.8H13.3C13.6866 2.8 14 3.1134 14 3.5C14 3.8866 13.6866 4.2 13.3 4.2H12.5518L11.9447 12.6997C11.8923 13.4324 11.2827 14 10.5482 14H3.45178C2.71729 14 2.10767 13.4324 2.05534 12.6997L1.44822 4.2H0.7C0.313401 4.2 0 3.8866 0 3.5C0 3.1134 0.313401 2.8 0.7 2.8H2.09422C2.09856 2.79996 2.1029 2.79996 2.10722 2.8H3.5V1.4ZM4.9 2.8H9.1V1.4H4.9V2.8ZM2.85178 4.2L3.45178 12.6H10.5482L11.1482 4.2H2.85178ZM5.6 5.6C5.9866 5.6 6.3 5.9134 6.3 6.3V10.5C6.3 10.8866 5.9866 11.2 5.6 11.2C5.2134 11.2 4.9 10.8866 4.9 10.5V6.3C4.9 5.9134 5.2134 5.6 5.6 5.6ZM8.4 5.6C8.7866 5.6 9.1 5.9134 9.1 6.3V10.5C9.1 10.8866 8.7866 11.2 8.4 11.2C8.0134 11.2 7.7 10.8866 7.7 10.5V6.3C7.7 5.9134 8.0134 5.6 8.4 5.6Z" fill="#346F8B"/></svg>
                                </div>
                            </div>

                        `,
                        data: function(){
                            return {
                                data: {}
                            }
                        },
                        methods: {
                            onClick(mode) {
                                switch(mode){
                                    case 'EDIT':
                                        context.openModal(this.data, 'EDIT')
                                        break;
                                    case 'DELETE':
                                        context.openModal(this.data, 'DELETE')
                                        break;
                                    case 'PASSWORD':
                                        context.openModal(this.data, 'SHOW_PASSWORD_PIN')
                                        break;
                                }
                            }
                        }
                    })
                }
            },
            systemsFilter: listFilter(() => distinctNames(this.users, 'systems')),
            systemGroupsFilter: listFilter(() => distinctNames(this.users, 'systemGroups')),
            systemsTemplate: ellipsisTemplate('systemsText'),
            systemGroupsTemplate: ellipsisTemplate('systemGroupsText')
        }
    },
    methods: {
        async getData() {
            this.$store.dispatch('set_loading', true)
            let result = await getUserSystems();
            this.users = result.map(u => ({
                ...u,
                systemsText: joinNames(u.systems),
                systemGroupsText: joinNames(u.systemGroups)
            }))
            this.$store.dispatch('set_loading', false)
        },
        async deleteUser() {
            await deleteUser(this.activeUser.id);
            this.getData();
            this.closeModal()
        },
        openModal(user, mode) {
            this.activeUser = user
            this.deleteText = this.$t('Delete') + ' ' + (this.activeUser != null ? this.activeUser.fullName : '');
            this.activeModal = mode
        },
        closeModal(mode){
            this.activeUser = null
            this.activeModal = 'NONE'
            if(mode == 'getData')
                this.getData()
        },
        closePinModal() {
            this.activeModal = 'SHOW_RESET_PASSWORD_MODAL'
        },

        toolbarClick: function(args) {
            switch(args.item.id){
                case 'addUser':
                    this.openModal(null, 'ADD')
                    break;
                case 'table-title':
                    this.getData();
                    break;
                case "pdf-export":
                    this.$refs.grid.pdfExport();
                    break;
                case "csv-export":
                    this.$refs.grid.csvExport();
                    break;
                case "excel-export":
                    this.$refs.grid.excelExport();
                    break;
                case 'clear-filters':
                    this.$refs.grid.clearFiltering();
                    break;
            }
        },
        dataBound: function() {
            this.$refs.grid.autoFitColumns();
        },
    },
    mounted: async function () {
        await this.getData();

        context = this
    },
}
</script>

<style scoped>
    .table {
        border-top: none;
        border-left: none;
        border-right: none;
    }

    .table tbody{
        border-left: 1px solid #A3D4E0;
        border-right: 1px solid #A3D4E0;
    }
    .e-grid .e-headercell.customcss{
        padding:0 5px 0 5px;
    }

    .e-grid .e-headercell .e-headercelldiv{
        padding-right:5px;
    }
    .e-gridchkbox.customcss .e-checkbox-wrapper{
        vertical-align: middle;
    }
</style>

<style>
    .tippy-tooltip.customTheme-theme {
      background-color: #346F8B;
    }

    .tippy-popper[x-placement^='left'] .tippy-tooltip.customTheme-theme .tippy-arrow {
      border-left: 8px solid #346F8B;
    }
</style>



// WEBPACK FOOTER //
// src/views/Users/Users.vue